import { render, staticRenderFns } from "./DocumentFilter.component.pug?vue&type=template&id=5493e3c6&scoped=true&lang=pug&"
import script from "./DocumentFilter.component.ts?vue&type=script&lang=ts&"
export * from "./DocumentFilter.component.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentFilter.component.scss?vue&type=style&index=0&id=5493e3c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5493e3c6",
  null
  
)

export default component.exports